<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-footer></app-footer>

<div class="content-page bg-gray">
    <div class="content p-1">
        <h4 class="px-2 text-dark">{{words[language].profile}}</h4>
        <div class="row m-0">
            <!-- settings panel -->
            <div class="col-md-2 p-1">
                <div class="rounded p-1 h-100">
                    <label class="w-100 text-center bg-main text-white px-1 py-2 rounded">
                        {{userInformation.firstName}}
                        {{userInformation.lastName}}</label>
                    <div class="d-flexflex-wrap mt-1">
                        <!-- go to Customer Information  -->
                        <button class="btn btn-transparent btn-block m-0 d-flex justify-content-start text-dark row" [ngClass]="{'text-primary': section==1}" (click)="section=1">{{words[language].personalInformation}}</button>
                        <!-- go to Account Settings -->
                        <button class="btn btn-transparent btn-block m-0 d-flex justify-content-start text-dark row" [ngClass]="{'text-primary': section==2}" (click)="section=2">{{words[language].accountSettings}}</button>
                    </div>
                </div>
            </div>
            
            <!-- form panel -->
            <div class="col-md-10 p-1">
                <div class="rounded p-1 text-dark">
                    @if (section==1 && !loading) {
                        <customer-information-form [user]="userInformation"></customer-information-form>
                    }
                    @if (section==2) {
                        <account-settings-form [user]="userInformation"></account-settings-form>
                    }
                </div>
            </div>
        </div>
    </div>
    
